import { render, staticRenderFns } from "./ProgramOverviewList.vue?vue&type=template&id=63afc32a"
import script from "./ProgramOverviewList.vue?vue&type=script&lang=js"
export * from "./ProgramOverviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports